(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/password-recovery/components/password-recovery-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/password-recovery/components/password-recovery-form.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const MobileInput = svs.ui.reactFormInputs.MobileInput;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  RadioButton = _svs$ui$reactForm.RadioButton;
const Button = svs.ui.ReactButton;
const _svs$ticket_partner$p = svs.ticket_partner.passwordRecovery.constants.FORMS.MOBILE,
  MOBILE_LABEL = _svs$ticket_partner$p.MOBILE_LABEL,
  MOBILE_NAME = _svs$ticket_partner$p.MOBILE_NAME;
const _svs$ticket_partner$p2 = svs.ticket_partner.passwordRecovery.constants.FORMS,
  RESTORE_OPTION_HEADER = _svs$ticket_partner$p2.RESTORE_OPTION_HEADER,
  RESTORE_OPTIONS = _svs$ticket_partner$p2.RESTORE_OPTIONS;
const _svs$ticket_partner$u = svs.ticket_partner.utils,
  showErrorDialog = _svs$ticket_partner$u.showErrorDialog,
  showSuccessDialog = _svs$ticket_partner$u.showSuccessDialog;
const _svs$ticket_partner$s = svs.ticket_partner.services,
  recoverPassword = _svs$ticket_partner$s.recoverPassword,
  passwordRecoveryErrorMapper = _svs$ticket_partner$s.passwordRecoveryErrorMapper;
const _React = React,
  useState = _React.useState;
const PasswordRecoveryForm = _ref => {
  let email = _ref.email,
    restoreOptions = _ref.restoreOptions,
    onRecoveySuccess = _ref.onRecoveySuccess;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    mobile = _useState2[0],
    setMobile = _useState2[1];
  const _useState3 = useState(restoreOptions[0] || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    restoreOption = _useState4[0],
    setRestoreOption = _useState4[1];
  const restoreOptionToText = restoreOption => {
    if (restoreOption === RESTORE_OPTIONS.SMS.value) {
      return RESTORE_OPTIONS.SMS.text;
    }
    if (restoreOption === RESTORE_OPTIONS.LETTER.value) {
      return RESTORE_OPTIONS.LETTER.text;
    }
    return '';
  };
  const handlePasswordRecoverySubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let isValid = _ref2.isValid;
      return !isValid;
    })) {
      return;
    }
    try {
      await recoverPassword({
        deliveryChannel: restoreOption,
        userName: email,
        cellPhone: mobile
      });
      showSuccessDialog("Vi har nu skickat ditt l\xF6senord via ".concat(restoreOptionToText(restoreOption), "."), 'Lösenord skickat', () => {
        setRestoreOption('');
        setMobile('');
        onRecoveySuccess();
      });
    } catch (error) {
      showErrorDialog(passwordRecoveryErrorMapper(error));
    }
  };
  return React.createElement(Form, {
    onSubmit: handlePasswordRecoverySubmit
  }, React.createElement("h1", {
    className: "f-bold"
  }, RESTORE_OPTION_HEADER), React.createElement(RadioGroup, {
    size: "200"
  }, React.createElement(RadioButton, {
    checked: restoreOption === RESTORE_OPTIONS.SMS.value,
    disabled: !restoreOptions.includes(RESTORE_OPTIONS.SMS.value),
    label: RESTORE_OPTIONS.SMS.label,
    onChange: setRestoreOption,
    value: RESTORE_OPTIONS.SMS.value
  }), React.createElement(RadioButton, {
    checked: restoreOption === RESTORE_OPTIONS.LETTER.value,
    disabled: !restoreOptions.includes(RESTORE_OPTIONS.LETTER.value),
    label: RESTORE_OPTIONS.LETTER.label,
    onChange: setRestoreOption,
    value: RESTORE_OPTIONS.LETTER.value
  })), restoreOption === 'TextMessage' ? React.createElement(MobileInput, {
    label: MOBILE_LABEL,
    name: MOBILE_NAME,
    onChange: e => setMobile(e.target.value),
    value: mobile
  }) : null, React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Button, {
    inverted: true,
    type: "submit"
  }, "Forts\xE4tt")));
};
svs.ticket_partner.passwordRecovery.PasswordRecoveryForm = PasswordRecoveryForm;

 })(window);